import { render, staticRenderFns } from "./FormHistoryBtn.vue?vue&type=template&id=960ba8e4"
import script from "./FormHistoryBtn.vue?vue&type=script&setup=true&lang=js"
export * from "./FormHistoryBtn.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports